<template>
    <div>
        <div class="title-box-primary flex-align-center">
            <h2 class="title">友情链接</h2>
        </div>
        <div
            class="link-box"
            ref="wrapper"
            @mouseenter="enterhandle"
            @mouseleave="leavehandle"
        >
            <div class="content" ref="text" :style="{ left: textLeft }">
                <a
                    class="link"
                    v-for="link in friendLink"
                    :src="link.image"
                    :key="link.title"
                    @click="goToUrl(link)"
                >
                    <img style="cursor: pointer;" @load="ulWidth" :src="link.image" />
                </a>
            </div>
        </div>
        <!-- <ul class="ul-box">
            <div ref="ulRef1">
                <li v-for="(item, index) in friendLink" :key="index" :ref="'imgSize' + index"><img @load="ulWidth" class="ul-div"
                        :src="item.image" alt=""></li>
            </div>
        </ul> -->
        <!-- <div class="link-box">
            <ul ref="ulRef">
                <li v-for="link in friendLink" :key="link.title"><img @load="ulWidth" :src="link.image" alt=""></li>
            </ul>
        </div> -->
    </div>
</template>
<script>
import { getadvinfo } from "@/network/homeIndex";
export default {
    data() {
        return {
            friendLink: [],
            textLeft: "",
            textTransition: "",
            againTime: 0,
            textWidth: 0,
            transTime: 0,
            wrapperWidth: 0,
            liWidth:0
        };
    },
    mounted() {
        // 友情链接
        getadvinfo({
            category_id: 5,
            type: 0,
        }).then((res) => {
            if (res.data.length > 0) {
                // let list = res.data.slice(0, 3)
                // for (let index = 0; index < list.length; index++) {
                //     const element = list[index];
                //     res.data.push(element)
                // }
                console.log(res.data, res.data.slice(0, 3), '--------------------------')
                this.friendLink = res.data;
                this.$nextTick(() => {
                    this.marquee()
                })
            }
        });

    },
    methods: {

        goToUrl(e) {
            console.log(e)
            if (e.url != '') {
                window.open(e.url, "_blank")
            }
        },
        ulWidth(e){
            this.liWidth += e.target.offsetWidth
            console.log(this.liWidth)
        },
        enterhandle() {
            if (this.pmdTimer) {
                clearInterval(this.pmdTimer);
                this.pmdTimer = null;
            }
        },
        leavehandle() {
            this.scrollLink();
        },
        // 跑马灯运作
        marquee() {
            this.wrapperWidth = this.$refs.wrapper.clientWidth; // 容器的总宽度
            console.log(this.wrapperWidth)

            this.textWidth = this.liWidth; // 文本的总宽度
            this.textLeftNum = this.wrapperWidth;
            this.textLeft = this.textLeftNum + "px"; // 开始滚动前设定文本在容器最右侧以外
            this.scrollLink();
        },
        scrollLink() {
            this.pmdTimer = setInterval(() => {
                this.textLeftNum = this.textLeftNum - 2;
                if (this.textLeftNum < -this.liWidth) {
                    this.textLeftNum = this.wrapperWidth;
                    this.textLeft = this.textLeftNum + "px";
                } else {
                    this.textLeft = this.textLeftNum + "px";
                }
            }, 10);
        },
    },
};
</script>
<style lang="less" scoped>
.title-box-primary {
    padding-top: 60px;
    padding-bottom: 16px;

    .title {
        line-height: 1;
        padding-left: 44px;
        background: url(~@/assets/images/title-icon.png) left center / 24px auto no-repeat;
        color: #12214d;
        font-size: 24px;
        font-weight: bold;
    }
}

.link-box {
    padding: 30px 0;
    border: 1px solid #d7dae3;
    overflow: hidden;
    height: 112px;
}

.content {
    display: inline-block;
    position: relative;
    left: 0;
    white-space: nowrap;
}

.link-box .link {
    margin-right: 47px;
}

.link-box .link.pmd-animate {
    transition: all ease 0.5s;
    transform: translateX(-100%);
}

.link-box .link:last-child {
    margin-right: 0;
}

.link-box img {
    max-width: none;
    height: 60px;
}
</style>